// Import necessary modules from react-router-dom library
import { createBrowserRouter, redirect } from "react-router-dom";

// Import view components for the routes
import CaseSummaryOneView from "../views/case-summary-one-view";
import Auth from "../views/auth-msal";
import Error404 from "../views/error-404";

// Create a browser router and define routes
const router = createBrowserRouter([
    {
        // Root route ("/")
        path: '/',
        // Renders the Auth component when the user visits the root route
        element:  <Auth />,
        // Renders a div with "404" when an error occurs in this route
        errorElement: <Error404 />
    },
    {
        // Route for case summary one view, capturing multiple URL parameters
        path: 'caseSummaryOneView',
        // Renders the CaseSummaryOneView component when the user visits this route
        element: <CaseSummaryOneView />,
        // Renders a div with "404" when an error occurs in this route
        errorElement: <Error404 />
    }
])

// Export the configured router
export default router;